// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Vaibhav's Portfolio",
  description:
    "An aspiring Android Developer | UI/UX Designer | Competitive Programmer",
  og: {
    title: "Vaibhav Jaiswal's Portfolio",
    type: "website",
    url: "http://vaibhav2002.github.io/",
  },
};
//

//Home Page
const greeting = {
  title: "Vaibhav Jaiswal",
  logo_name: "VaibhavJaiswal",
  nickname: "Vaibhav2002",
  subTitle:
    "An aspiring Android Developer, UI/UX Designer and Competitive Programmer",
  resumeLink:
    "https://drive.google.com/file/d/1axri4REwi3p7h0CdgHq_Cp1dS82pdhPC/view?usp=sharing",
  portfolio_repository: "https://github.com/Vaibhav2002",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Vaibhav2002",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link:
      "https://www.linkedin.com/in/vaibhav-jaiswal-8612621b7/?originalSubdomain=in",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCSFxdyVJlLmwXTJEJZhHNug",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:vaibhavsam2511@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/Vaibhav53658105",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/vaibhav.jaiswal.902604",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/vaibhav.jaiswal.2511/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Android Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building robust android application using Native Android with Kotlin",
        "⚡ Building android apps using Modern Android Development practices",
        "⚡ Creating application backend in Firebase, Spring Boot or Ktor",
      ],
      softwareSkills: [
        {
          skillName: "Android",
          fontAwesomeClassname: "fa-android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "simple-icons:kotlin",
          style: {
            color: "#766DB2",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
      ],
    },
    {
      title: "Backend Development",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Creating backend application using Spring Boot and Ktor",
        "⚡ Deploying backend on cloud to use on mobile devices",
        "⚡Setting up most SQL and NoSQL databases like PostgreSQL, MongoDB and many more",
      ],
      softwareSkills: [
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#336791",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/vaibhav_jaiswal3",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/vaibhav2511",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@vaibhav_jaiswal",
    },
    {
      siteName: "leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#fb9c1c",
      },
      profileLink: "https://leetcode.com/vaibhav_jaiswal/",
    },
    {
      siteName: "geeksforgeeks",
      iconifyClassname: "simple-icons:geeksforgeeks",
      style: {
        color: "#308d46",
      },
      profileLink: "https://auth.geeksforgeeks.org/user/vaibhav2511/profile",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Bachelor of Technology",
      subtitle: "Information Technology",
      logo_path: "rcc.png",
      alt_name: "RCCIIT",
      duration: "2021 - 2025",
      descriptions: [
        "⚡ Studying B.Tech IT in RCC Institute of Information Technology",
        "⚡ Won few coding contest hosted by the Tech Club of College, and will win more",
      ],
      website_link: "https://www.rcciit.org",
    },
    {
      title: "High School",
      subtitle: "ISC Class XII",
      logo_path: "spms.png",
      alt_name: "SPMS",
      duration: "2018 - 2020",
      descriptions: [
        "⚡ I have studied basic ISC subjects and got 84% in Best of 3 subjects.",
        "⚡ I was quite good in Computer Science and had good interest in it and got 98% in Computer Science.",
      ],
      website_link: "http://stpaulsmissionschoolkolkata.org",
    },
    {
      title: "Middle School",
      subtitle: "ICSE Class X",
      logo_path: "spms.png",
      alt_name: "SPMS",
      duration: "2007 - 2018",
      descriptions: [
        "⚡ I have studied basic ICSE subjects and got 86% in Best of 4 subjects.",
        "⚡ I was quite good in Computer Science starting from class 10 (used to fail before) and had good interest in it and got 99% in Computer Science.",
        "⚡ I was good in Mathematics and scored 97% in Maths.",
      ],
      website_link: "http://stpaulsmissionschoolkolkata.org",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Java",
      subtitle: "- HackerRank",
      logo_path: "hackerrank.png",
      certificate_link: "https://www.hackerrank.com/certificates/ea03a6d1429f",
      alt_name: "Hackerrank",
      color_code: "#ffffff",
    },
    {
      title: "Problem Solving Basic",
      subtitle: "- HackerRank",
      logo_path: "hackerrank.png",
      certificate_link: "https://www.hackerrank.com/certificates/232a3027d363",
      alt_name: "Hackerrank",
      color_code: "#ffffffff",
    },
    {
      title: "SQL Basic",
      subtitle: "- HackerRank",
      logo_path: "hackerrank.png",
      certificate_link: "https://www.hackerrank.com/certificates/b3009ba4fc4a",
      alt_name: "Hackerrank",
      color_code: "#FFFFFFFF",
    },
    {
      title: "Python",
      subtitle: "- HackerRank",
      logo_path: "hackerrank.png",
      certificate_link: "https://www.hackerrank.com/certificates/9c576b5caf80",
      alt_name: "Hackerrank",
      color_code: "#ffffffff",
    },
    {
      title: "Java+Android Level 1 ",
      subtitle: "- Cambridge Certification Authority",
      logo_path: "CCA.png",
      certificate_link:
        "https://github.com/Vaibhav2002/Certificates/blob/main/CCA-Certificate-Java%20Level%201.png",
      alt_name: "CCA",
      color_code: "#1F70C199",
    },
    {
      title: "Java+Android Level 2",
      subtitle: "- Cambridge Certification Authority",
      logo_path: "CCA.png",
      certificate_link:
        "https://github.com/Vaibhav2002/Certificates/blob/main/CCA-Certificate-Java%20Level%202.png",
      alt_name: "CCA",
      color_code: "#1F70C199",
    },
    {
      title: "Python Level 2",
      subtitle: "- Cambridge Certification Authority",
      logo_path: "CCA.png",
      certificate_link:
        "https://github.com/Vaibhav2002/Certificates/blob/main/CCA-Certificate-Python%20Level%201.png",
      alt_name: "CCA",
      color_code: "#1F70C199",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as an Android Developer. ",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Lead Android Developer",
          company: "Mapstreak Pvt. Ltd.",
          company_url: "http://www.mapstreak.com",
          logo_path: "mapstreak_logo.png",
          duration: "Feb 2021 - Sept 2021",
          location: "Work from home",
          description:
            "I am working on a food ordering android application which delivers tiffin, restaurant food and many more to people working at offices,etc. Building 2 apps, one for user and one for merchant. Following modern android development practices to make sure app is bug free. Following software design principles to make sure app is acalable",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineer Intern - Android",
          company: "Pratilipi",
          company_url: "https://www.pratilipi.com",
          logo_path: "pratilipi.png",
          duration: "April 2022 - Present",
          location: "Bangalore, Currently Remote",
          description:
            "I am working with Pratilipi on the IVM Podcast team. IVM Podcast is a podcast application which is used by thousands of users worldwide.",
          color: "#d0021b",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "March 2021 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Android Apps using Kotlin and following Modern Android Development practices which includes Android Jetpack and Android Architecture Components. I have also built some backend applications using Ktor and Spring Boot.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "vaibhav_logo_rounded.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with  Android, Backend and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I also write blogs when i get some free time from work. My blogs are mostly on my projects, Android development and many more.",
    link: "https://vaibhav2002.hashnode.dev",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Kolkata, West Bengal, India",
    avatar_image_path: "address_image.svg",
    location_map_link: "",
  },
  phoneSection: {
    title: "Email",
    subtitle: "vaibhav.jaiswal3011@gmail.com",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
